import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage/storage.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Component({
	selector: 'app-advisor-operations',
	templateUrl: './advisor-operations.component.html',
	styleUrls: ['./advisor-operations.component.scss']
})
export class AdvisorOperationsComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() page_data: any;
	@Input() page_operation_type: any;

	@Output() advisorOperationsClosed = new EventEmitter<any>();
	@Output() advisorOperationsUpdated = new EventEmitter<any>();

	current_date: any = new Date();
	user_details: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
		public datePipe: DatePipe,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		this.getProductGroups();
		this.getGenders();
		this.getAdvisorStatus();
		this.getStates();
		this.getAdvisorTypes();
		this.getLicenses();
		this.getCertificates();
		this.getEmploymentTypes();
		this.getDesignations();
		this.getRegion();
		this.getServicesOffered();
		this.getProfessionalAssociations();
		this.calculateYears();

		setTimeout(() => {
			this.openAdvisorOperationModal();
		}, 200);
	}

	product_group_list: any = [];
	getProductGroups() {
		if(this.user_details.financial_institution != null){
			let route = '/productGroup?financial_institution=' + this.user_details.financial_institution + '&no_page=true/'
			this.commonService.getData(route).subscribe(
				(res: any) => {
					this.product_group_list = res;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}else{
			this.product_group_list = []
		}
	}

	genders_list: any = [];
	getGenders() {
		this.commonService.getData('/gender?no_page=true/').subscribe(
			(res: any) => {
				this.genders_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	advisor_status_list: any = [];
	getAdvisorStatus() {
		this.commonService.getData('/advisorStatus?no_page=true/').subscribe(
			(res: any) => {
				this.advisor_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	states_list: any = [];
	getStates() {
		this.commonService.getData('/state?no_page=true/').subscribe(
			(res: any) => {
				this.states_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	region_list: any = [];
	getRegion() {
		this.commonService.getData('/region?financial_institution=' + this.user_details.financial_institution + '&no_page=true/').subscribe(
			(res: any) => {
				this.region_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	advisor_type_list: any = [];
	getAdvisorTypes() {
		this.commonService.getData('/advisorType?no_page=true/').subscribe(
			(res: any) => {
				this.advisor_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	licenses_list: any = [];
	getLicenses() {
		this.commonService.getData('/licenses?no_page=true/').subscribe(
			(res: any) => {
				this.licenses_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	certificates_list: any = [];
	getCertificates() {
		this.commonService.getData('/certificates?no_page=true/').subscribe(
			(res: any) => {
				this.certificates_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	employment_type_list: any = [];
	getEmploymentTypes() {
		this.commonService.getData('/employmentType?no_page=true/').subscribe(
			(res: any) => {
				this.employment_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	designation_list: any = [];
	getDesignations() {
		this.commonService.getData('/designation?no_page=true/').subscribe(
			(res: any) => {
				this.designation_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}


	services_offered_list: any = [];
	getServicesOffered() {
		this.commonService.getData('/servicesOffered?no_page=true/').subscribe(
			(res: any) => {
				this.services_offered_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	professional_associations_list: any = [];
	getProfessionalAssociations() {
		this.commonService.getData('/professionalAssociations?no_page=true/').subscribe(
			(res: any) => {
				this.professional_associations_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	represent_years: any = [];
	calculateYears() {
		let current_year = new Date().getFullYear();
		const limit = 70;
		for (let index = 0; index < limit; index++) {
			this.represent_years.push(current_year);
			current_year = current_year - 1;
		}
	}

	@ViewChild('pageOperationsModal') pageOperationsModal: TemplateRef<any>;
	private pageOperationsModalRef: MatDialogRef<TemplateRef<any>>;
	openAdvisorOperationModal() {
		if (this.page_operation_type == 'Add') {
			this.page_data = JSON.parse(JSON.stringify(this.ideal_page_data));
			this.page_data.status = 'Active';

		} else {
			this.page_data.date_of_birth = this.datePipe.transform(this.page_data.date_of_birth, 'MM-dd-yyyy');
			this.page_data.date_of_joining = this.datePipe.transform(this.page_data.date_of_joining, 'MM-dd-yyyy');
		}

		this.pageOperationsModalRef = this.dialog.open(this.pageOperationsModal, { disableClose: true } );
		this.pageOperationsModalRef.afterClosed().subscribe((result) => {
			this.closeAdvisorOperationModal();
		});
	}

	closeAdvisorOperationModal() {
		this.advisorOperationsClosed.emit("Closed");
		this.pageOperationsModalRef.close();
	}

	page_operation_stepper: any = 1;
	navigateBack() {
		this.page_operation_stepper = this.page_operation_stepper - 1;
	}

	validateAdvisorDetails() {
		if (this.page_operation_stepper == 1) {
			const fields = [
				{ key: "advisor_id", type: "text" },
				{ key: "first_name", type: "text" },
				{ key: "last_name", type: "text" },
				{ key: "email", type: "email" },
				{ key: "date_of_birth", type: "date" },
				{ key: "advisor_status_id", type: "text" },
				{ key: "address_line_1", type: "text" },
				{ key: "city", type: "text" },
				{ key: "state_id", type: "text" },
				{ key: "region_id", type: "text" },
				{ key: "zip_code", type: "text" },
			];

			if (this.validateAdvisorIndividualSection(fields)) {
				this.page_operation_stepper = this.page_operation_stepper + 1;
			}

		} else if (this.page_operation_stepper == 2) {
			const fields = [
				{ key: "total_experience", type: "text" },
				{ key: "states_registered", type: "list" },
				{ key: "certificates", type: "list" },
				{ key: "professional_associations", type: "list" },
			];

			if (this.validateAdvisorIndividualSection(fields)) {
				if (this.page_data.is_primary_contact == true) {
					if ((this.page_data.adults_in_household != "" && this.page_data.adults_in_household != null) || (this.page_data.adults_in_household == "0")) {
						this.page_data_errors.adults_in_household = false;
					} else {
						this.page_data_errors.adults_in_household = true;
					}

					if ((this.page_data.children_in_household != "" && this.page_data.children_in_household != null) || (this.page_data.children_in_household == "0")) {
						this.page_data_errors.children_in_household = false;
					} else {
						this.page_data_errors.children_in_household = true;
					}

					if ((this.page_data.household_income_in_dollars_actual != "" && this.page_data.household_income_in_dollars_actual != null) || this.page_data.household_income_in_dollars_actual == "0") {
						this.page_data_errors.household_income_in_dollars_actual = false;
					} else {
						this.page_data_errors.household_income_in_dollars_actual = true;
					}

					if (
						this.page_data_errors.adults_in_household == false &&
						this.page_data_errors.children_in_household == false &&
						this.page_data_errors.household_income_in_dollars_actual == false
					) {
						this.page_data_errors.adults_in_household = false;
						this.page_data_errors.children_in_household = false;
						this.page_data_errors.household_income_in_dollars_actual = false;
						this.page_operation_stepper = this.page_operation_stepper + 1;
					}
				} else {
					this.page_operation_stepper = this.page_operation_stepper + 1;
				}
			}
		} else if (this.page_operation_stepper == 3) {
			const fields = [
				{ key: "financial_institution_branch", type: "text"},
				{ key: "date_of_joining", type: "text"},
			];

			if (this.validateAdvisorIndividualSection(fields)) {
				this.page_operation_stepper = this.page_operation_stepper + 1;
			}
		} else if (this.page_operation_stepper == 4) {
			if (this.advisor_experience_operation_type == "") {
				this.saveAdvisorInformation();
			}
		}
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
	}

	validEmail(email) {
		if (
			email != '' &&
			/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
		) {
			return true;
		} else {
			return false;
		}
	}

	global_error: boolean = false;
	validateAdvisorIndividualSection(fields) {
		if (fields.length > 0) {
			// let error: boolean = false;
			this.global_error = false;
			for (let index = 0; index < fields.length; index++) {
				if (fields[index].type == "text" || fields[index].type == "number" || fields[index].type == "date") {
					if (this.page_data[fields[index]["key"]] != "" && this.page_data[fields[index]["key"]] != null) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				} else if (fields[index].type == "email") {
					if (this.page_data[fields[index]["key"]] != "" && this.page_data[fields[index]["key"]] != null && this.validEmail(this.page_data[fields[index]["key"]])) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				} else if (fields[index].type == "boolean") {
					if (this.page_data[fields[index]["key"]] == true || this.page_data[fields[index]["key"]] == false) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				}
			}

			// if (error == true) {
			// 	return false;
			// } else {
			// 	return true;
			// }

			if (this.global_error == true) {
				return false;
			} else {
				return true;
			}

		} else {
			this.global_error = false
			return true;
		}
	}

	saveAdvisorInformation() {
		this.page_data.date_of_birth = this.datePipe.transform(this.page_data.date_of_birth, 'yyyy-MM-dd');
		this.page_data.date_of_joining = this.datePipe.transform(this.page_data.date_of_joining, 'yyyy-MM-dd');

		if (this.page_operation_type == 'Add') {
			this.commonService.postData('/advisor/', this.page_data).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Advisor has been added successfully.');
					this.advisorOperationsUpdated.emit("Added");

					this.pageOperationsModalRef.close();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		} else {
			this.commonService.updateData('/advisor/' + this.page_data.id + '/', this.page_data).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Advisor has been updated successfully.');
					this.advisorOperationsUpdated.emit("Updated");

					this.pageOperationsModalRef.close();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}


	ideal_page_data: any = {
		advisor_id: "",
		first_name: "",
		last_name: "",
		phone_number: "",
		email: "",
		gender_id: "",
		date_of_birth: "",
		advisor_status_id: "",
		address_line_1: "",
		address_line_2: "",
		city: "",
		state_id: "",
		region_id: "",
		zip_code: "",
		address_2_line_1: "",
		address_2_line_2: "",
		address_2_city: "",
		address_2_state_id: "",
		address_2_region_id: "",
		address_2_zip_code: "",
		address_3_line_1: "",
		address_3_line_2: "",
		address_3_city: "",
		address_3_state_id: "",
		address_3_region_id: "",
		address_3_zip_code: "",
		linkedin_url: "",
		twitter_url: "",
		facebook_url: "",
		total_experience: "",
		states_registered: [],
		total_licenses: [],
		certificates: [],
		professional_associations: [],
		advisor_type_id: "",
		dually_licensed: false,
		dually_registered: false,
		regulatory_disclosures: false,
		sells_insurance_products: false,
		sells_retirement_products: false,
		date_became_representative_year: "",
		employment_id: "",
		employment_type_id: "",
		financial_institution: {
			institution_name: "",
			branches: []
		},
		financial_institution_branch: "",
		designation_id: "",
		date_of_joining: "",
		product_experience: [],
		employment_details: [],
	};

	page_data_errors: any = {
		advisor_id: false,
		first_name: false,
		last_name: false,
		phone_number: false,
		email: false,
		gender_id: false,
		date_of_birth: false,
		advisor_status_id: false,
		address_line_1: false,
		address_line_2: false,
		city: false,
		state_id: false,
		region_id: false,
		zip_code: false,
		address_2_line_1: false,
		address_2_line_2: false,
		address_2_city: false,
		address_2_state_id: false,
		address_2_region_id: false,
		address_2_zip_code: false,
		address_3_line_1: false,
		address_3_line_2: false,
		address_3_city: false,
		address_3_state_id: false,
		address_3_region_id: false,
		address_3_zip_code: false,
		linkedin_url: false,
		twitter_url: false,
		facebook_url: false,
		total_experience: false,
		states_registered: false,
		total_licenses: false,
		certificates: false,
		professional_associations: false,
		advisor_type_id: false,
		dually_licensed: false,
		dually_registered: false,
		regulatory_disclosures: false,
		sells_insurance_products: false,
		sells_retirement_products: false,
		date_became_representative_year: false,
		employment_id: false,
		employment_type_id: false,
		financial_institution: {
			institution_name: false,
			branches: false,
		},
		financial_institution_branch: false,
		designation_id: false,
		date_of_joining: false,
		product_experience: false,
		employment_details: false,
	};

	advisor_experience_details: any = {
		prior_employment_id: "",
		company_name: "",
		start_date: "",
		end_date: "",
		work_years: "",
	};
	advisor_experience_operation_type: any = "";
	advisor_experience_operation_index: any = null;
	advisor_experience_details_errors: any = {
		prior_employment_id: false,
		company_name: false,
		start_date: false,
		end_date: false,
		work_years: false,
	};

	advisorExperienceOperations(data, type, index) {
		this.advisor_experience_details = JSON.parse(JSON.stringify(data));
		this.advisor_experience_operation_type = type;
		this.advisor_experience_operation_index = index;
	}

	validateAdvisorExperience() {
		if (
			this.advisor_experience_details.prior_employment_id != "" && this.advisor_experience_details.prior_employment_id != null
		) {
			this.advisor_experience_details_errors.prior_employment_id = false;
		} else {
			this.advisor_experience_details_errors.prior_employment_id = true;
		}

		if (
			this.advisor_experience_details.company_name != "" && this.advisor_experience_details.company_name != null
		) {
			this.advisor_experience_details_errors.company_name = false;
		} else {
			this.advisor_experience_details_errors.company_name = true;
		}

		if (
			this.advisor_experience_details.start_date != "" && this.advisor_experience_details.start_date != null
		) {
			this.advisor_experience_details_errors.start_date = false;
		} else {
			this.advisor_experience_details_errors.start_date = true;
		}

		if (
			this.advisor_experience_details.end_date != "" && this.advisor_experience_details.end_date != null
		) {
			this.advisor_experience_details_errors.end_date = false;
		} else {
			this.advisor_experience_details_errors.end_date = true;
		}

		if (
			this.advisor_experience_details.work_years != "" && this.advisor_experience_details.work_years != null
		) {
			this.advisor_experience_details_errors.work_years = false;
		} else {
			this.advisor_experience_details_errors.work_years = true;
		}

		if (
			this.advisor_experience_details_errors.prior_employment_id == false &&
			this.advisor_experience_details_errors.company_name == false &&
			this.advisor_experience_details_errors.start_date == false &&
			this.advisor_experience_details_errors.end_date == false &&
			this.advisor_experience_details_errors.work_years == false
		) {
			return true;
		} else {
			return false;
		}
	}

	saveAdvisorExperience() {
		if (this.validateAdvisorExperience()) {
			if (this.advisor_experience_operation_type == "Add") {
				this.page_data.employment_details.push(this.advisor_experience_details);
				this.cancelAdvisorExperience();
			} else {
				if (this.advisor_experience_details.id) {
					const index = this.page_data.employment_details.findIndex((x) => x.id == this.advisor_experience_details.id);
					this.page_data.employment_details.splice(index, 1, this.advisor_experience_details);
					this.cancelAdvisorExperience();
				} else {
					this.page_data.employment_details.splice(this.advisor_experience_operation_index, 1, this.advisor_experience_details);
					this.cancelAdvisorExperience();
				}
			}
		}

	}

	cancelAdvisorExperience() {
		this.advisor_experience_details = {
			prior_employment_id: "",
			company_name: "",
			start_date: "",
			end_date: "",
			work_years: "",
		};
		this.advisor_experience_operation_type = "";
		this.advisor_experience_operation_index = null;
		this.advisor_experience_details_errors = {
			prior_employment_id: false,
			company_name: false,
			start_date: false,
			end_date: false,
			work_years: false,
		};
	}

	@ViewChild('deleteAdvisorExperienceModal') deleteAdvisorExperienceModal: TemplateRef<any>;
	private deleteAdvisorExperienceModalRef: MatDialogRef<TemplateRef<any>>;
	deleteAdvisorExpeience(data, index) {
		this.advisor_experience_details = JSON.parse(JSON.stringify(data));
		this.advisor_experience_operation_index = JSON.parse(JSON.stringify(index));
		this.deleteAdvisorExperienceModalRef = this.dialog.open(this.deleteAdvisorExperienceModal, { disableClose: true });
		this.deleteAdvisorExperienceModalRef.afterClosed().subscribe((result) => {
			this.closeAdvisorExpeienceGoal();
		});
	}

	closeAdvisorExpeienceGoal() {
		this.cancelAdvisorExperience();
		this.deleteAdvisorExperienceModalRef.close();
	}

	deleteAdvisorExpeienceDetails() {
		if (this.advisor_experience_details.id) {
			const index = this.page_data.employment_details.findIndex((x) => x.id == this.advisor_experience_details.id);
			this.page_data.employment_details.splice(index, 1);
			this.closeAdvisorExpeienceGoal();
		} else {
			this.page_data.employment_details.splice(this.advisor_experience_operation_index, 1);
			this.closeAdvisorExpeienceGoal();
		}
	}

}
